<template>
  <div class="row">
    <div class="col-20 std-wrapper mt-0 p-3 px-4 pt-4">
      <div class="row">
        <div
          v-if="isAdvertiser"
          class="col-20 col-md-6"
        >
          <data-display
            :title="$t('view-CampaignsCpc.index.membersCount')"
            class="mb-4 d-block"
          >
            {{ campaign.membersCount || 0 }}
          </data-display>
        </div>
        <div
          v-if="isAdvertiser"
          class="col-20 col-md-6 offset-md-1 col-b"
        >
          <data-display
            :title="$t('view-CampaignsCpc.index.credits')"
            :textarea="true"
            class="mb-4 d-block"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-inline-block">
                {{ campaign.credits }} {{ $currencySymbol(campaign.currency) }}
              </div>
              <router-link
                v-if="campaign.status !== 'canceled'"
                :to="{ name: 'campaign-cpc-credits', params: { id: campaign.id } }"
                class="nh-btn add-credits d-inline-block"
              >
                <span class="pr-2">+</span> <span>{{ $t('view-CampaignsCpc.Credits.button.add') }}</span>
              </router-link>
            </div>
          </data-display>
        </div>
        <div
          v-if="!isAdvertiser"
          class="col-20 col-md-12"
        >
          <span v-if="campaign.member && !campaign.member.banned">
            {{ $t('view-CampaignsCpc.your_ref_link') }}<br>
            <b-form-input
              v-model="campaign.member.ref_link"
              type="text"
              :disabled="true"
            />
            <small>{{ $t('view-CampaignsCpc.your_ref_link_info') }}</small>
          </span>
          <span v-else-if="campaign.member">
            <span class="text-danger">{{ $t('view-CampaignsCpc.you_are_banned') }}</span>
            <data-display
              :title="$t('view-CampaignsCpc.reason')"
              class="mt-2 d-block"
            >
              {{ campaign.member.ban_message }}
            </data-display>
          </span>
          <span v-else>
            {{ $t('view-CampaignsCpcDetails.you_are_not_member') }}<br>
            <std-button
              type="A"
              :title="$t('view-CampaignsCpcDetails.join')"
              add-class="mx-2 my-2"
              :loader="buttonLoader"
              @click="joinHandler"
            />
          </span>
        </div>
        <div class="col-20 col-md-6 offset-md-1 col-b d-flex flex-wrap align-items-center justify-content-end">
          <status
            :status="campaign.status"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleDataDisplay from '../../../components/SimpleDataDisplay.vue'
import status from '../common/Status.vue'

export default {
  components: {
    'data-display': SimpleDataDisplay,
    status: status
  },
  props: {
    campaign: {
      type: Object,
      default: () => { return {} }
    },
    isAdvertiser: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      buttonLoader: false
    }
  },
  methods: {
    joinHandler () {
      if (this.buttonLoader) {
        return
      }

      this.buttonLoader = true

      this.$store.dispatch('campaignsCpcInfluencer/join', this.campaign.id)
        .then(async (newItem) => {
          await this.$store.dispatch('campaignsCpcInfluencer/getOne', this.campaign.id).catch(() => {})
          this.$flash.success(this.$t('view-CampaignsCpc.join.message.successfull'))
          this.buttonLoader = false
        })
        .catch((e) => {
          this.$flash.error(this.$t('view-CampaignsCpc.join.message.error'))
          this.buttonLoader = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @include media-breakpoint-up(md) {
    .col-b {
      border-left: 1px solid $nh-gray;
    }
  }
  .add-credits {
    background-color: $warning;
    border: 2px solid $warning;
    color: white;
    border-radius: 5px;
    padding: 0.35rem;
    margin: -0.35rem;
    &:hover {
      text-decoration: none;
      color: $warning;
      background-color: white;
    }
  }
</style>
